import { useState } from "react";
import ConfirmDialogModal from "../confirmDialog";
import RefreshIcon from "../../../../images/icon_refresh.svg";
import { useResetDocumentStatusMutation } from "../../../../api/drivers";
import { sendSuccessMessage } from "../../../../constants/extras/sendSuccessMsg";

const ResetDocumentStatus = (props) => {
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [resetDocumentStatusReq, { isLoading: resetDocumentStatusLoading }] = useResetDocumentStatusMutation();

  const getBodyText = () => {
    switch (props?.title) {
      case "Selfie Status":
        return `Are you sure you want to reset the selfie review status ${props?.status} to Pending ?`;

      case "License Status":
        return `Are you sure you want to reset the driver's license review status ${props?.status} to Pending?`;

      case "Insurance Status":
        return `Are you sure you want to reset the insurance review status ${props?.status} to Pending?`;

      case "Signature Status":
        return `Are you sure you want to reset the signature review status ${props?.status} to Pending?`;

      default:
        return "Are you sure you want to reset this document status?";
    }
  };

  const getDocType = () => {
    switch (props?.title) {
      case "Selfie Status":
        return `selfie`;

      case "License Status":
        return `driversLicense`;

      case "Insurance Status":
        return `insurancePolicy`;

      case "Signature Status":
        return `signature`;
    }
  };


  const handleResetDocumentStatus = async () => {
    try {
      const payload = {
        id: props?.driver?._id,
        docType: getDocType(),
        reasons: props?.reasons
      }
      const result = await resetDocumentStatusReq(payload).unwrap();
      sendSuccessMessage(result?.message);
      setOpenConfirmationModal(false)
      props?.refreshData()

    } catch (error) {
      console.log("handleResetDocumentStatus -> error", error)
    }
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>{props?.status}</span>
        {(
          (props?.driver?.status !== "approved" &&
            props?.driver?.status !== "rejected") &&
          (props?.status === "Approved" ||
            props?.status === "Rejected")
        ) && (
            <span style={{ cursor: "pointer", background: "#fff", border: "none" }} onClick={() => setOpenConfirmationModal(true)}>
              <img
                src={RefreshIcon}
                alt="RefreshIcon"
                style={{ width: "20px", height: "20px" }}
              />
            </span>
          )}
      </div>

      {openConfirmationModal && (
        <ConfirmDialogModal
          title={`Reset Document Status`}
          bodyText={getBodyText()}
          isOpen
          isLoading={resetDocumentStatusLoading}
          confirmAction={handleResetDocumentStatus}
          onClose={() => {
            setOpenConfirmationModal(false);
          }}
        />
      )}
    </div>
  );
};

export default ResetDocumentStatus;
